export function assert(condition: unknown, message: string): asserts condition {
  if (!condition) throw new Error(message)
}

/** Marks a branch the types rule out, e.g. the default case of an exhaustive switch. */
export function unreachable(value: never): never {
  throw new Error(`Unreachable: ${String(value)}`)
}
